import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { worldwideContinents } from '../data/mock';

export const WorldwideJourneysPage = () => {
  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />

      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-secondary)',
        padding: '120px 0 80px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Worldwide Journeys
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Venture beyond Indonesia with expertly curated international experiences. From Himalayan spiritual journeys to luxury cruises, we design transformative travel that connects culture, adventure, and unforgettable moments.
          </p>
        </div>
      </section>

      {/* Continental Cards Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {worldwideContinents.map((continent) => (
              <Link
                key={continent.id}
                to={`/worldwide-journeys/${continent.id}`}
                style={{
                  textDecoration: 'none',
                  display: 'block',
                  borderRadius: 0,
                  overflow: 'hidden',
                  background: 'var(--bg-primary)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                className="region-card"
              >
                <div style={{
                  width: '100%',
                  height: '240px',
                  overflow: 'hidden'
                }}>
                  <img
                    src={continent.image}
                    alt={continent.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    className="region-card-image"
                  />
                </div>
                <div style={{ padding: '24px' }}>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                    {continent.name}
                  </h3>
                  <p className="body-regular" style={{ 
                    color: 'var(--text-secondary)', 
                    marginBottom: '16px',
                    lineHeight: 1.6,
                    minHeight: '72px'
                  }}>
                    {continent.description}
                  </p>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#FBBF24',
                    fontSize: '14px',
                    fontWeight: 400,
                    transition: 'color 0.3s ease'
                  }}
                  className="explore-region-link">
                    Explore region
                    <ArrowRight size={16} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .region-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.1);
        }
        .region-card:hover .region-card-image {
          transform: scale(1.05);
        }
        .region-card:hover .explore-region-link {
          color: #D4AF37;
        }
        @media (max-width: 1200px) {
          section .container > div {
            grid-template-columns: repeat(3, 1fr) !important;
          }
        }
        @media (max-width: 768px) {
          section .container > div {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 480px) {
          section .container > div {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};
